<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.specialMultiple.query.type')" prop="type">
                <a-select
                  v-model="queryParam.type"
                  allow-clear
                  :placeholder="$t('views.specialMultiple.query.typePlaceholder')"
                  style="width: 100%"
                >
                  <a-select-option :value="0">{{ $t('views.specialMultiple.type.0') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('views.specialMultiple.type.1') }}</a-select-option>
                  <a-select-option :value="2">{{ $t('views.specialMultiple.type.2') }}</a-select-option>
                  <a-select-option :value="3">{{ $t('views.specialMultiple.type.3') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.specialMultiple.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.specialMultiple.btn.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:specialMultiple:add']">
          <a-icon type="plus" />{{ $t('views.specialMultiple.btn.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:specialMultiple:edit']">
          <a-icon type="edit" />{{ $t('views.specialMultiple.btn.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:specialMultiple:remove']">
          <a-icon type="delete" />{{ $t('views.specialMultiple.btn.delete') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="displayColumns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="cellDash" slot-scope="text">
          {{ formatCellText(text) }}
        </span>
        <span slot="type" slot-scope="text, record">
          {{ formatCellText(formatTypeLabel(record.type)) }}
        </span>
        <!-- 表格排序列已注释
        <span slot="sort" slot-scope="text, record">
          <a-input-number
            :value="record.sort"
            :min="0"
            style="width: 100px"
            @change="(value) => handleSortChange(record, value, 'sort')"
          />
        </span>
        -->
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ formatDateTimeCell(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:specialMultiple:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:specialMultiple:edit']">
            <a-icon type="edit" />{{ $t('views.specialMultiple.btn.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['user:specialMultiple:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:specialMultiple:remove']">
            <a-icon type="delete" />{{ $t('views.specialMultiple.btn.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="showPaginationTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageSpecialMultiple, delSpecialMultiple, updateSpecialMultiple } from '@/api/user/specialMultiple'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'SpecialMultiple',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        type: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '',
          dataIndex: 'id',
          scopedSlots: { customRender: 'cellDash' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'productType',
          scopedSlots: { customRender: 'cellDash' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'subType',
          scopedSlots: { customRender: 'cellDash' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'expression',
          scopedSlots: { customRender: 'cellDash' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'lowerLimitExclusive',
          scopedSlots: { customRender: 'cellDash' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'upperLimitInclusive',
          scopedSlots: { customRender: 'cellDash' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'mode',
          scopedSlots: { customRender: 'cellDash' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'multiplier',
          scopedSlots: { customRender: 'cellDash' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'specOptionNames',
          scopedSlots: { customRender: 'cellDash' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '',
        //   dataIndex: 'sort',
        //   scopedSlots: { customRender: 'sort' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    displayColumns () {
      const titleKeyByDataIndex = {
        id: 'views.specialMultiple.column.id',
        type: 'views.specialMultiple.column.type',
        productType: 'views.specialMultiple.column.productType',
        subType: 'views.specialMultiple.column.subType',
        expression: 'views.specialMultiple.column.expression',
        lowerLimitExclusive: 'views.specialMultiple.column.lowerLimitExclusive',
        upperLimitInclusive: 'views.specialMultiple.column.upperLimitInclusive',
        mode: 'views.specialMultiple.column.mode',
        multiplier: 'views.specialMultiple.column.multiplier',
        specOptionNames: 'views.specialMultiple.column.specOptionsList',
        // sort: 'views.specialMultiple.column.sort',
        status: 'views.specialMultiple.column.status',
        createTime: 'views.specialMultiple.column.createTime',
        operation: 'views.specialMultiple.column.operation'
      }
      return this.columns.map(col => {
        const key = titleKeyByDataIndex[col.dataIndex]
        return {
          ...col,
          title: key ? this.$t(key) : col.title
        }
      })
    }
  },
  watch: {
  },
  methods: {
    showPaginationTotal (total) {
      return this.$t('views.specialMultiple.pagination.total', { total })
    },
    isEmptyCell (val) {
      if (val === null || val === undefined) {
        return true
      }
      if (typeof val === 'string' && val.trim() === '') {
        return true
      }
      return false
    },
    formatCellText (val) {
      return this.isEmptyCell(val) ? '-' : val
    },
    formatDateTimeCell (timeVal) {
      if (this.isEmptyCell(timeVal)) {
        return '-'
      }
      const s = this.parseTime(timeVal)
      return this.isEmptyCell(s) ? '-' : s
    },
    formatTypeLabel (val) {
      if (val === null || val === undefined || val === '') {
        return ''
      }
      const n = Number(val)
      if (Number.isNaN(n) || n < 0 || n > 3) {
        return String(val)
      }
      return this.$t('views.specialMultiple.type.' + n)
    },
    /** 查询特殊倍数列表 */
    getList () {
      this.loading = true
     pageSpecialMultiple(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        type: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      const idsText = Array.isArray(ids) ? ids.join(',') : String(ids)
      this.$confirm({
        title: this.$t('views.specialMultiple.confirm.deleteTitle'),
        content: this.$t('views.specialMultiple.confirm.deleteContent', { ids: idsText }),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delSpecialMultiple(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.specialMultiple.msg.deleteOk'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('views.specialMultiple.confirm.exportTitle'),
        content: this.$t('views.specialMultiple.confirm.exportContent'),
        onOk () {
          that.download('user/special-multiple/export', {
            ...that.queryParam
          }, that.$t('views.specialMultiple.export.filename', { time: new Date().getTime() }))
        },
        onCancel () {}
      })
    },
    /** 状态开关变更 */
    handleStatusChange (record, checked) {
      const statusValue = checked ? 1 : 0
      const updateData = {
        id: record.id,
        status: statusValue
      }
      updateSpecialMultiple(updateData).then(() => {
        record.status = statusValue
        this.$message.success(this.$t('views.specialMultiple.msg.statusUpdateOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.specialMultiple.msg.statusUpdateFail'))
      })
    },
    /** 排序值变更 */
    handleSortChange (record, value, fieldName) {
      if (value === null || value === undefined) {
        return
      }
      const updateData = {
        id: record.id
      }
      updateData[fieldName] = value
      updateSpecialMultiple(updateData).then(() => {
        record[fieldName] = value
        this.$message.success(this.$t('views.specialMultiple.msg.sortUpdateOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.specialMultiple.msg.sortUpdateFail'))
      })
    }
  }
}
</script>
